var _excluded = ["formatToParts", "locale"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultOptions = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  locale: 'en-GB'
};
var getDate = function getDate(date) {
  return typeof date === 'string' ? new Date(date) : date;
};
var getDateFormatter = function getDateFormatter(opts) {
  var _defaultOptions$opts = _objectSpread(_objectSpread({}, defaultOptions), opts),
    formatAsParts = _defaultOptions$opts.formatToParts,
    locale = _defaultOptions$opts.locale,
    dateTimeFormatOptions = _objectWithoutProperties(_defaultOptions$opts, _excluded);
  return Intl.DateTimeFormat(locale, dateTimeFormatOptions);
};
var getDatePartsMap = function getDatePartsMap(parts) {
  return parts.reduce(function (map, part) {
    /*
      Exclude 'literal' type object(s), such as ones containing spaces, commas,
      and other separators.
    */
    if (part.type === 'literal') {
      return map;
    }
    return _objectSpread(_objectSpread({}, map), {}, {
      [part.type]: part
    });
  }, {});
};
export var formatDate = function formatDate(dateValue, options) {
  var formatter = getDateFormatter(options);
  var date = getDate(dateValue);
  if (options !== null && options !== void 0 && options.formatToParts) {
    var parts = formatter.formatToParts(date);
    return getDatePartsMap(parts);
  }
  return formatter.format(date);
};